export default {
  hero: {
    tagline: "Life is beautiful if you",
    taglineHighlight: "act beautiful",
    subtitle: "Where innovation meets elegance in every solution we create",
    scroll: "Scroll",
  },
  banner: {
    brandName: "BURA",
    imageAlt: "Bura brand showcase",
    cards: {
      faranack: { name: "Faranack", role: "Frontend Developer & ML Researcher" },
      javad: { name: "Javad", role: "Full-Stack Developer & Electronic Engineer" },
    },
    taglinePrefix: "It's not just a name; it's a",
    taglineHighlight: "promise of quality",
    taglineSuffix: "and innovation.",
  },
  about: {
    heading: "About",
    headingHighlight: "Us",
    subheading:
      "Two passionate innovators creating sustainable solutions for modern challenges",
    story: {
      title: "Our Story",
      lead: "Frontend & backend development, IoT, and embedded systems.",
      body: "Our expertise spans across multiple industries including retail, healthtech, and education, delivering innovative solutions that make a real impact.",
    },
    mission: {
      title: "Our Mission",
      body: "To create innovative, sustainable, and impactful technology solutions that solve real-world problems and empower businesses to thrive in the digital age.",
    },
    stats: {
      teamMembers: "Team Members",
      projects: "Projects",
      yearsExperience: "Years Experience",
      clientSatisfaction: "Client Satisfaction",
    },
    expertiseTitle: "Our Expertise",
    skills: {
      dataScience: "Data Science",
      webDevelopment: "Web Development",
      mobileApplications: "Mobile Applications",
      iotSolutions: "IoT Solutions",
      embeddedSystems: "Embedded Systems",
      aiMl: "AI & Machine Learning",
      cloudArchitecture: "Cloud Architecture",
      devops: "DevOps",
    },
  },
  iot: {
    headingPrefix: "This is our",
    headingHighlight: "profession",
    subtitle:
      "Crafting intelligent solutions through innovative technology and creative engineering",
    indicators: {
      iotSolutions: "IoT Solutions",
      smartEngineering: "Smart Engineering",
      innovation: "Innovation",
    },
  },
  whatWeDo: {
    heading: "What We Do",
    subtitle:
      "Driving innovation through specialized services tailored to your unique challenges and aspirations.",
    items: {
      softwareDevelopment: {
        title: "Software Development",
        description:
          "As front-end and back-end developers, we create innovative software solutions, crafting intuitive user experiences and robust server-side functionalities to empower businesses and users alike.",
      },
      artificialIntelligence: {
        title: "Artificial Intelligence",
        description:
          "Our artificial intelligence projects harness cutting-edge technology to build intelligent systems that learn, adapt, and solve complex problems, driving innovation across industries.",
      },
      internetOfThings: {
        title: "Internet of Things",
        description:
          "Our Internet of Things projects create smart and connected devices, enabling seamless communication and data exchange, enhancing efficiency, and transforming everyday experiences.",
      },
      electronicEngineering: {
        title: "Electronic Engineering",
        description:
          "Our electronic engineering projects involve designing and developing innovative electronic systems, circuits, and devices to address real-world challenges and enhance technological advancements.",
      },
    },
  },
  contact: {
    heading: "Get in Touch",
    subtitle:
      "Let's create something extraordinary together. We're excited to bring your vision to life.",
    methods: {
      telegram: { title: "Telegram", desc: "Quick chat & support" },
      email: { title: "Email", desc: "Detailed inquiries" },
    },
    footerNote: "Thank you for visiting • Ready to innovate together",
  },
};
